
// pour référence vers le code B.C.
// @todo - Aurait-on pu / dü mettre en place un service ?
var Terrassor_INTERFACE;

// getter/setter pour INTERFACE. Sinon la variable est inaccessible (pb import / export et webpack, ou read-only)
export function set_Terrassor_INTERFACE(o)
  {
    Terrassor_INTERFACE = o
  }

export function get_Terrassor_INTERFACE()
  {
    return Terrassor_INTERFACE
  }

  export function Terrassor_RECALCULATE() {
  	console.log('Terassor_RECALCULATE all')
  	return  get_Terrassor_INTERFACE().action({"table":"all", "calculate":''});
  }



// WEBPACK FOOTER //
// ./src/client/interface.js